//import React, { useEffect } from "react";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Post } from "./Post";
import { logOutOutline, chevronBackOutline } from 'ionicons/icons';
import FooterComponent from "../FooterComponent";
import LoginCheck from "../LoginCheck";
import { get, remove } from '../../services/storage.service';
import axios from 'axios';
import { useIonViewWillEnter } from "@ionic/react";

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonButton,
  IonToolbar,
  IonIcon,
} from "@ionic/react";

export default function PostContainer() {
  let { postid } = useParams<any>();
  const [posts, setPosts] = useState<any>({});
  //const [postName, setPostName] = useState<string>("");
  const history = useHistory();
  useIonViewWillEnter(() => {
    console.log('--call the page again--');
  });
    useEffect(() => {
      async function loadPosts() {
      get("cred")
        .then(function (finalResult) { //get the user data to authenticate the user
            const userD = JSON.parse(finalResult);
            //console.log(userD.email);
            //axios.get('https://expmindapp.wpengine.com/wp-json/mind/v2/single/?id=' + postid, {
            axios.get('https://explorermindsetapp.com/wp-json/mind/v2/single/?id=' + postid, {
                headers: {
                  'Authentication': 'Bearer ' + userD.authtoken
                },
                timeout: 8000
            })
                .then(function (serverResponse) {
                    const posts = serverResponse.data[0];
                    console.log(serverResponse);
                    console.log(posts);
                    setPosts(posts);
                    console.log(posts.title);
                    console.log(serverResponse.data[0]);
                })
                .catch(function (error) {
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        console.log(error.request)
                    } else {
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                });
        }).catch(err => {//unable to load the local storage
            console.log("e: " + err.message);
        });
      }
      loadPosts();
  }, [postid]);
  function logOut(){
    console.log("logout");
    remove('cred');
    history.push('/home/');
  }
  return ( 
    <>
    <IonPage>
      <LoginCheck/>
      <IonHeader translucent={true} >
        <IonToolbar>
          <IonButton size="small" slot="start" color="primary" onClick={() => history.goBack()} class="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
          <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  class="logout"><IonIcon slot="start" icon={logOutOutline}/>Log Out</IonButton>
        
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large"></IonTitle>
          </IonToolbar>
        </IonHeader>
        <Post posts={posts} />

        <IonButton onClick={() => document?.querySelector("ion-content")?.scrollToTop(500) } style={{marginLeft:'40px'}}>Top</IonButton>
      </IonContent>
      <FooterComponent/>
    </IonPage>
    </>
  );
}
